// 引用css
import "../scss/base.scss";
import "../scss/main.scss";
// 开发引用html，热更新
if (process.env.NODE_ENV === "development") {
    require("raw-loader!../index.html");
    require("raw-loader!../_main.html");
}

// 兼容低版本ie
import "es5-shim";
import "es5-shim/es5-sham";


import * as service from "./service";
service.init();
import { viewPoint } from './pointUtils.js';
// 访问页面
viewPoint({ eventType: '访问页面', eventReason: 'pc' });

import './main';

// 如果需要头部脚部就打开注释
// import header from "headerES";
// var domain = "gevents.37games.com"; //ocean.location.getDomain();
// 
// header.render(domain, ".cm-top-bg");
// 

// import footer from "footerES";
// footer.render(domain ".j-f_common_footer");
